import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatDataTileComponent } from './stat-data-tile.component';
import { MsTooltipModule } from '../ms-tooltip/ms-tooltip.component';

@NgModule({
  imports: [CommonModule, MsTooltipModule],
  declarations: [StatDataTileComponent],
  exports: [StatDataTileComponent],
})
export class StatDataTileModule {}
